import React from 'react'
import { useState, useEffect } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { Height } from '@mui/icons-material'
import Sidebar from './Sidebar'
import Videos from './Videos'
import { fetchFromAPI } from '../utils/fetchFromAPI'
const Feed = () => {
    const [Video, setVideo] = useState([])
    const [selectedCategory, setselectedCategory] = useState('New')
    useEffect(() => {
        fetchFromAPI(`search?part=snippet&q=${selectedCategory}`).then((data) => {setVideo(data.items)})
    }, [selectedCategory])
  return (
    <Stack sx={{
        flexDirection: {sx: 'column', md: 'row'}
    }}>
        <Box sx={{height: {sm: 'auto', md: '92vh'},
                    borderRight:'1px solid #3d3d3d', px: {sx: 0, md: 2}}}>
            <Sidebar
            selectedCategory = {selectedCategory}
            setselectedCategory = {setselectedCategory}/>


        </Box>

        <Box p={2} sx={{overflowY: 'auto', height: '90vh'}}>
           <Typography variant='h4' fontWeight='bold' mb={2} sx={{color: 'white'}}> 

           {selectedCategory} <span style={{color: '#FC1503'}}>
                Videos
            </span>
            </Typography> 
            <Videos video={Video}/>
        </Box>

    </Stack>
  )
}

export default Feed